import { URLS } from "@constants/urls";
import { Text } from "@pentabd/ui";

const employeeService = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.REPORTS}`;

const functionalityService = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.REPORTS}`;

const promotionService = `${process.env.REACT_APP_PROMOTION_SERVICE_URL}${process.env.REACT_APP_PROMOTION_SERVICE_PORT}/${process.env.REACT_APP_PROMOTION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

const resignationService = `${process.env.REACT_APP_RESIGNATION_SERVICE_URL}${process.env.REACT_APP_RESIGNATION_SERVICE_PORT}/${process.env.REACT_APP_RESIGNATION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;
export const reports = [
  {
    id: 1,
    name: "Appointed through promotion",
    nameBn: "পদোন্নতির মাধ্যমে নিয়োগকৃত",
    fetchUrl: `${promotionService}/promotion-yearly-report/info`,
    downloadUrl: "promotion-yearly-report",
    column: [
      {
        id: 1,
        name: "পদোন্নতিপ্রাপ্ত পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName}</Text>
        ),
      },
      {
        id: 2,
        name: "পদোন্নতিকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount}</Text>
        ),
      },
    ],
  },
  {
    id: 2,
    name: "Appointed through deputation",
    nameBn: "প্রেষণে যোগদানকৃত",
    fetchUrl: `${employeeService}/yearly-deputation-joining-report/info`,
    downloadUrl: "deputation-yearly-report",
    column: [
      {
        id: 1,
        name: "যোগদানকৃত পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName || "N/A"}</Text>
        ),
      },
      {
        id: 2,
        name: "যোগদানকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount || "N/A"}</Text>
        ),
      },
    ],
  },
  {
    id: 3,
    name: "Exempted from deputation",
    nameBn: "প্রেষণ হতে অবমুক্ত",
    fetchUrl: `${functionalityService}/yearly-release-report/info`,
    downloadUrl: "release-yearly-report",
    column: [
      {
        id: 1,
        name: "অবমুক্তকৃত পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName || "N/A"}</Text>
        ),
      },
      {
        id: 2,
        name: "অবমুক্তকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount || "N/A"}</Text>
        ),
      },
    ],
  },
  {
    id: 4,
    name: "PRL Information",
    nameBn: "পিআরএল তথ্য",
    fetchUrl: `${employeeService}/yearly-prl-report/info`,
    downloadUrl: "prl-yearly-report",
    column: [
      {
        id: 1,
        name: "পিআরএলকৃত পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName || "N/A"}</Text>
        ),
      },
      {
        id: 2,
        name: "পিআরএলকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount || "N/A"}</Text>
        ),
      },
    ],
  },
  {
    id: 5,
    name: "Death/Deceased Information",
    nameBn: "মৃত্যুবরণের তথ্য",
    fetchUrl: `${employeeService}/yearly-death-report/info`,
    downloadUrl: "death-yearly-report",
    column: [
      {
        id: 1,
        name: "মৃত্যুবরণকৃত পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName || "N/A"}</Text>
        ),
      },
      {
        id: 2,
        name: "মৃত্যুবরণকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount || "N/A"}</Text>
        ),
      },
    ],
  },
  {
    id: 6,
    name: "Resigned Information",
    nameBn: "ইস্তফাকৃত তথ্য",
    fetchUrl: `${resignationService}/resignation-yearly-report/info`,
    downloadUrl: "resignation-yearly-report",
    column: [
      {
        id: 1,
        name: "ইস্তফাকৃত পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName || "N/A"}</Text>
        ),
      },
      {
        id: 2,
        name: "ইস্তফাকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount || "N/A"}</Text>
        ),
      },
    ],
  },
  {
    id: 7,
    name: "Appointed directly",
    nameBn: "সরাসরি নিয়োগকৃত",
    fetchUrl: `${employeeService}/yearly-recruitment-report/info`,
    downloadUrl: "recruitment-yearly-report",
    column: [
      {
        id: 1,
        name: "পদের নাম",
        key: "positionName",
        render: (positionName: string) => (
          <Text color="subtitle1">{positionName || "N/A"}</Text>
        ),
      },
      {
        id: 2,
        name: "সরাসরি নিয়োগকৃত কর্মকর্তা/কর্মচারীর সংখ্যা",
        key: "totalAmount",
        render: (totalAmount: number) => (
          <Text color="subtitle1">{totalAmount || "N/A"}</Text>
        ),
      },
    ],
  },
];
